var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#298752",
    id: "check-circle",
    d: "M18.375,3.375a15,15,0,1,0,15,15A15,15,0,0,0,18.375,3.375Zm7.68,10.853-9.642,9.685h-.007a1.3,1.3,0,0,1-.837.4,1.263,1.263,0,0,1-.844-.411l-4.038-4.038a.287.287,0,0,1,0-.411l1.284-1.284a.279.279,0,0,1,.4,0l3.2,3.2,8.8-8.863a.285.285,0,0,1,.2-.087h0a.262.262,0,0,1,.2.087l1.262,1.305A.284.284,0,0,1,26.055,14.228Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/check-circle-green.ce23e2b44ea49a9672ade9dcc9313bb2.svg";
export { ForwardRef as ReactComponent };